import { Callout, ExternalLink } from "@octopusdeploy/design-system-components";
import type { CommunicationStyle } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues } from "@octopusdeploy/octopus-server-client";
import useLocalStorage from "~/hooks/useLocalStorage";
interface KubernetesLiveStatusCalloutProps {
    machineEndpointSummaries: Record<CommunicationStyle, number>;
}
export function KubernetesLiveStatusCallout({ machineEndpointSummaries }: KubernetesLiveStatusCalloutProps) {
    const [calloutDismissed, setCalloutDismissed] = useLocalStorage<boolean>("Octopus.Callout.DeploymentTargets.KubernetesLiveStatus.Dismissed", false);
    const hasKubernetesApiTargets = (machineEndpointSummaries[CommunicationStyleValues.Kubernetes] ?? 0) > 0;
    const hasKubernetesAgentTargets = (machineEndpointSummaries[CommunicationStyleValues.KubernetesTentacle] ?? 0) > 0;
    if (calloutDismissed || !hasKubernetesApiTargets || hasKubernetesAgentTargets) {
        return null;
    }
    return (<Callout type="new-feature" title="Kubernetes live object status is now generally available" canClose onClose={() => setCalloutDismissed(true)}>
            To enable live status, you'll need a Kubernetes agent that supports the Octopus Kubernetes Monitor. <ExternalLink href="kubernetes-agent">Install the latest version</ExternalLink> of the agent in your cluster.
        </Callout>);
}
